<template>
    <div>
        <v-card class="score-chart ma-1">
            <v-container>
                <v-card-title>
                    <span class="caption-font white--text"><v-avatar size="40" class="damages mr-4"><v-icon color="white">mdi-glass-fragile</v-icon></v-avatar>Damages</span>
                </v-card-title>
                <span class="br_medium"></span>
                <v-row class="white--text ml-4 mb-6">
                    <table style="width:80%">
                        <tr v-for="claim in claims" :key="claim.key">
                            <td class="td_markup_xl">{{ claim.text }}</td>
                            <td style="text-align: right;" class="td_markup_xl">{{ claim.num }}</td>
                        </tr>
                    </table>
                </v-row>
                <v-divider color="white"></v-divider>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn v-bind="attrs" v-on="on" icon v-on:click="openSubScreen()">
                                <v-icon>mdi-open-in-app</v-icon>
                            </v-btn>
                        </template>
                        <span style="text-align: right;">Damages overview...</span>
                    </v-tooltip>
                </v-card-actions>
            </v-container>
        </v-card>
        <linkHuovHosm ref="linkHuovHosm"></linkHuovHosm>
    </div>
</template>
<script>

import linkHuovHosm from "./huovHosm.vue";
import { bus } from "../../../../main";

export default {
    props: {
        gebr: {
            type: Object,
            default: () => ({}),
        }
    },
    components: {
        linkHuovHosm,
    },
    data() {
        return {
            claims: [],
        }
    },
    created() {
        //console.log('created');
        // here we will add the axios call to get the bookings from ares and assign the bookings var
        this.getClaimsOverview();
        bus.$on("refresh", (data) => {
            console.log("refresh received for damages " + data);
            this.getClaimsOverview();
        });
    },
    mounted() {
        //console.log('mounted');
        //this.getClaimsOverview();
    },
    methods: {
        openSubScreen() {

            //this.$refs.linkHuovHosm.open(this.gebr.gebr_code);
            let route = this.$router.resolve({ path: '/task/customer_success/hosm/hosm_overview/user:' + this.gebr.gebr_xencrid }); //props: ['huis_encrid'],
            window.open(route.href, '_blank');

        },
        getClaimsOverview() {
            this.$axios
                .post("ares/json/ares/syst/dashboard/getClaimsOverview.p", {
                    header: {
                        token: this.$session.get("ARES"),
                        clientSessionId: this.$session.id(),
                        request: "getClaimsOverview"
                    },
                })
                .then(res => {
                    if (res.data.error) {
                        console.log(res.data.error);
                    } else {
                        this.claims = res.data.getClaimsOverview;
                    }
                })
                .finally(() => {
                });
        },
    }
}
</script>
<style scoped>
    .score-chart {
        background: url('../assets/background_tile.png') !important;
        background-size: cover !important;
    }

    .br_medium {
        display: block;
        margin-bottom: 1em;
    }

    .caption-font {
        font-size: 30px;
        font-weight: bold;
    }

    .td_markup_xl {
        font-size: 17px !important;
        line-height: 25px !important;
    }
    .damages {
        background: transparent !important;
        font-size: 12px !important;
        font-weight: 600 !important;
        border: 2px solid white;
        color: white;
        cursor: default;
    }    
</style>